export default class TransmittalSearchOptions {
  firstName?: string | null;
  lastName?: string | null;
  osis?: string | null;
  districtId?: number | null;
  schoolId?: number | null;
  programId?: number | null;
  serviceId?: number | null;
  statuses?: string[] | null;
  semesterId?: number | null;

  public constructor(
    params: TransmittalSearchOptions = {} as TransmittalSearchOptions
  ) {
    let {
      firstName = null,
      lastName = null,
      osis = null,
      districtId = null,
      schoolId = null,
      programId = null,
      serviceId = null,
      statuses = null,
      semesterId = null,
    } = params;
    this.firstName = firstName;
    this.lastName = lastName;
    this.osis = osis;
    this.districtId = districtId;
    this.schoolId = schoolId;
    this.programId = programId;
    this.serviceId = serviceId;
    this.statuses = statuses;
    this.semesterId = semesterId;
  }
}
